import { Row } from 'react-table';
import { IndependentIraUsersResponse } from 'services/requests';
import Table from 'components/Table';
import { AVALIABLE_ROWS_PER_PAGE } from 'components/Table/Table.constants';
import TableFooter from 'components/Table/TableFooter';

import {
  columns,
  IndependentIraUsersTableSign,
  MapData,
} from '../../IndependentIraTable/IndependentIraTable.columns';
import { HeaderFilters } from '../../IndependentIraTable/IndependentIraTable.filters';

type Props = {
  independentIraUsers?: IndependentIraUsersResponse;
  items?: MapData;
  onIraUserClick: (row: Row<IndependentIraUsersTableSign>) => void;
};

const RenderTable = ({
  independentIraUsers,
  items,
  onIraUserClick,
}: Props): JSX.Element | null =>
  independentIraUsers?.context ? (
    <Table<IndependentIraUsersTableSign>
      columns={columns}
      data={items || []}
      onRowClick={onIraUserClick}
      noFilterResults={items?.length === 0}
      headerFilters={{ ...HeaderFilters }}
    >
      {items && items?.length > 0 && (
        <TableFooter
          pages={independentIraUsers.context.pages}
          totalRows={independentIraUsers.context.totalRows}
          availableRowsPerPage={AVALIABLE_ROWS_PER_PAGE}
        />
      )}
    </Table>
  ) : null;

export default RenderTable;
